import { render, staticRenderFns } from "./medicalRecord.vue?vue&type=template&id=50b10fd0&scoped=true&"
import script from "./medicalRecord.vue?vue&type=script&lang=js&"
export * from "./medicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./medicalRecord.vue?vue&type=style&index=0&id=50b10fd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b10fd0",
  null
  
)

export default component.exports